import { Button } from '@material-ui/core'
import classnames from 'classnames'
import React from 'react'
import styled, { DefaultTheme, ThemeProps } from 'styled-components'

import { ValidFormValues } from '../../../lib/cart/types'

export interface PaymentMethodsProps {
  className?: string
  paymentMethod: ValidFormValues.PaymentDetails['code']
  setPaymentMethod: (value: ValidFormValues.PaymentDetails['code']) => void
  showPaymentMethods: boolean
  submitting: boolean
}

// TODO: Use real selectors from design system. (Currently styled to look similar.)
const PaymentMethods: React.FC<PaymentMethodsProps> = ({
  className,
  paymentMethod,
  setPaymentMethod,
  showPaymentMethods,
  submitting,
}) => {
  if (showPaymentMethods) {
    return (
      <div className={className}>
        <Button
          className={classnames('paymentMethodButton', {
            selected: paymentMethod === 'paradoxlabs_cybersource',
          })}
          color="primary"
          disabled={submitting}
          onClick={() => setPaymentMethod('paradoxlabs_cybersource')}
          variant={paymentMethod === 'paradoxlabs_cybersource' ? 'contained' : 'outlined'}
        >
          Credit Card
        </Button>
        <Button
          className={classnames('paymentMethodButton', {
            selected: paymentMethod === 'purchaseorder',
          })}
          color="primary"
          disabled={submitting}
          onClick={() => setPaymentMethod('purchaseorder')}
          variant={paymentMethod === 'purchaseorder' ? 'contained' : 'outlined'}
        >
          Pay by Invoice
        </Button>
      </div>
    )
  }

  return null
}

// /** @type StyledComponent<StyledComponentInnerComponent<(function({showPaymentMethods?: *, paymentMethod: *, setPaymentMethod: *, submitting: *, className: *}): (*|null))|*>, AnyIfEmpty<DefaultTheme>, StyledComponentInnerOtherProps<(function({showPaymentMethods?: *, paymentMethod: *, setPaymentMethod: *, submitting: *, className: *}): (*|null))|*>, StyledComponentInnerAttrs<(function({showPaymentMethods?: *, paymentMethod: *, setPaymentMethod: *, submitting: *, className: *}): (*|null))|*>> */
const StyledPaymentMethods = styled(PaymentMethods)(({ theme }: ThemeProps<DefaultTheme>) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '24px',
  marginRight: 'auto',
  width: '100%',
  '.paymentMethodButton': {
    alignItems: 'center',
    backgroundColor: theme.colors.coolGray.cool150,
    borderRadius: '8px',
    color: theme.colors.grayscale.black,
    cursor: 'pointer',
    display: 'flex',
    flex: '1',
    fontFamily: theme.fonts.global.body,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '125%',
    minHeight: '64px',
    paddingLeft: '16px',
    paddingRight: '16px',
    '&.disabled': {
      color: theme.colors.coolGray.cool450,
      cursor: 'not-allowed',
    },
    '&:first-child': {
      marginRight: '8px',
    },
    // Need some gnarly selectors here to 'defeat' Material UI rules.
    '&.MuiButton-root': {
      '&, &:hover': {
        textDecoration: 'none',
      },
    },
    '&.MuiButton-containedPrimary, &.MuiButton-outlinedPrimary': {
      backgroundColor: theme.colors.coolGray.cool150,
      border: '2px solid transparent',
      '&.selected': {
        border: `2px solid ${theme.colors.component.backgroundDarkBlue}`,
      },
    },
  },
  '@media(min-width: 600px)': {
    maxWidth: '475px',
    '.paymentMethodButton:first-child': {
      marginRight: '16px',
    },
  },
}))

export default StyledPaymentMethods
